import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  BidvBankTransferService,
  SyncTransactionDto,
  TransferStatusEntity,
} from 'services/openapi';
import { BidvBankTransferServiceKeys } from '../queries/constants';

export const useBidvSyncTransactionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<TransferStatusEntity, Error, SyncTransactionDto>({
    mutationFn: (variables) =>
      BidvBankTransferService.bidvBankTransferControllerSyncTransaction(
        variables,
      ),
    retry: 0,
    onSuccess: (response) => {
      const transactionCode = response.data.transactionCode;
      if (!transactionCode) return;
      queryClient.setQueryData(
        [BidvBankTransferServiceKeys.GET_TRANSFER_STATUS, transactionCode],
        response,
      );
    },
  });
};
